module.exports = __webpack_public_path__ + "img/实验室铅门.eb5743df.jpg";